import React, { useEffect, useState } from "react";

const reload = () => window.location.reload();

export class AppErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { failed: false }; }
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-[70vh] grid place-items-center px-6 text-center" data-testid="app-error">
        <div>
          <p className="font-serif font-bold text-2xl text-[#2B170C]">Le site vient d'être mis à jour</p>
          <p className="mt-2 text-[#6E5546]">Recharge la page pour afficher la nouvelle version.</p>
          <button type="button" data-testid="app-error-reload" onClick={reload} className="mt-5 btn-terra px-7 py-3 rounded-full font-semibold">Recharger la page</button>
        </div>
      </div>
    );
  }
}

export function AdminFallback() {
  const [slow, setSlow] = useState(false);
  useEffect(() => { const t = setTimeout(() => setSlow(true), 12000); return () => clearTimeout(t); }, []);
  return (
    <div className="min-h-screen grid place-items-center text-[#A08A7B] text-center px-6" data-testid="admin-loading">
      <div>
        <p>Chargement de l'administration…</p>
        {slow && <button type="button" data-testid="admin-loading-reload" onClick={reload} className="mt-4 btn-terra px-6 py-2.5 rounded-full font-semibold">Recharger la page</button>}
      </div>
    </div>
  );
}
